import React from "react"
import { injectIntl } from "react-intl"
import BaseStatBox from "../../../common/statbox/BaseStatBox"
import IntlProps from "../../../state/helpers/IntlProps"
import { messages } from "./messages"

type OwnProps = {
    amount: number
    currency: string
}

const StatBoxLastPayout = (props: OwnProps & IntlProps) => {

    return (
        <BaseStatBox
            title={props.intl.formatMessage(messages["lastPayoutTitle"])}
            amount={props.amount}
            currency={props.currency}
            displayTooltip={true}
            tooltipMessage={props.intl.formatMessage(messages["lastPayoutTooltipMessage"])}
        />
    )
}

export default injectIntl(StatBoxLastPayout)



// WEBPACK FOOTER //
// ./src/payment-processing/payout-listing/statBoxes/StatBoxLastPayout.tsx